/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sessionexpiredpleaseloginagain5Inputs */

const en_sessionexpiredpleaseloginagain5 = /** @type {(inputs: Sessionexpiredpleaseloginagain5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session expired. Please log in again.`)
};

const de_sessionexpiredpleaseloginagain5 = /** @type {(inputs: Sessionexpiredpleaseloginagain5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Sitzung ist abgelaufen. Bitte melde dich nochmal an.`)
};

/**
* | output |
* | --- |
* | "Session expired. Please log in again." |
*
* @param {Sessionexpiredpleaseloginagain5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sessionexpiredpleaseloginagain5 = /** @type {((inputs?: Sessionexpiredpleaseloginagain5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sessionexpiredpleaseloginagain5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sessionexpiredpleaseloginagain5(inputs)
	return de_sessionexpiredpleaseloginagain5(inputs)
});
export { sessionexpiredpleaseloginagain5 as "sessionExpiredPleaseLogInAgain" }